// import React, { useState } from "react";

// const UploadDocuments = (type) => {
//   const [gstVerify, setGstVerify] = useState(null);
//   const [aadharVerify, setAadharVerify] = useState(null);
//   const [passportVerify, setPassportVerify] = useState(null);
//   const [licenseVerify, setLicenseVerify] = useState(null);
//   const [fileName, setFileName] = useState("No uploads");

//   const uploadDocuments = (file) => {
//     var data = new FormData();
//     data.append("file", file);
//     let url = "http:localhost:3000/api/v1/";
//     if (type === "GST") {
//       url += "store/uploadGST";
//     } else if (type === "AADHAR") {
//       url += "store/uploadAadhar";
//     }
//     fetch(url, {
//       method: "POST",
//       body: data,
//     });
//   };
//   return (
//     // <div className="w-full h-[800px] flex items-center justify-center">
//     <div className="w-[959px] h-[480px] rounded-[20px] bg-white flex flex-col items-center justify-start">
//       <img
//         src={require("../../../assets/BuyerProfile/StoreManager/UploadDocuments/Naayatrade Final Logo File 1.jpg")}
//         alt=""
//         className="w-[31px] h-[39px]"
//       />
//       <h4 className="w-[411px] h-[21px] font-semibold text-[14px] text-black text-center mt-[16px]">
//         Upload documents for verification ( Allowed file type .pdf)
//       </h4>

//       <div className="w-[959px] h-[292px] flex flex-row gap-x-[21px]">
//         <div className="w-[224px] h-[292px] border rounded-[10px] flex flex-col">
//           <div className="w-full h-[242px] p-[13px] flex flex-col rounded-t-[10px]">
//             <div className="w-full flex justify-end">
//               <svg
//                 width="20"
//                 height="20"
//                 viewBox="0 0 20 20"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M10 1C8.21997 1 6.47991 1.52784 4.99987 2.51677C3.51983 3.50571 2.36628 4.91131 1.68509 6.55585C1.0039 8.20038 0.82567 10.01 1.17294 11.7558C1.5202 13.5016 2.37737 15.1053 3.63604 16.364C4.89471 17.6226 6.49836 18.4798 8.24419 18.8271C9.99002 19.1743 11.7996 18.9961 13.4442 18.3149C15.0887 17.6337 16.4943 16.4802 17.4832 15.0001C18.4722 13.5201 19 11.78 19 10C19 7.61305 18.0518 5.32387 16.364 3.63604C14.6761 1.94821 12.3869 1 10 1ZM10 17.5C8.51664 17.5 7.06659 17.0601 5.83323 16.236C4.59986 15.4119 3.63856 14.2406 3.07091 12.8701C2.50325 11.4997 2.35473 9.99168 2.64411 8.53682C2.9335 7.08196 3.64781 5.74559 4.6967 4.6967C5.7456 3.6478 7.08197 2.9335 8.53682 2.64411C9.99168 2.35472 11.4997 2.50325 12.8701 3.0709C14.2406 3.63856 15.4119 4.59985 16.236 5.83322C17.0601 7.06659 17.5 8.51664 17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5Z"
//                   fill="black"
//                   stroke="black"
//                   stroke-width="0.2"
//                 />
//                 <path
//                   d="M9.99938 8.27449C9.80047 8.27449 9.6097 8.35351 9.46905 8.49416C9.3284 8.63481 9.24938 8.82558 9.24938 9.02449V14.1245C9.24938 14.3234 9.3284 14.5142 9.46905 14.6548C9.6097 14.7955 9.80047 14.8745 9.99938 14.8745C10.1983 14.8745 10.3891 14.7955 10.5297 14.6548C10.6704 14.5142 10.7494 14.3234 10.7494 14.1245V9.02449C10.7494 8.82558 10.6704 8.63481 10.5297 8.49416C10.3891 8.35351 10.1983 8.27449 9.99938 8.27449ZM9.99938 5.19949C9.79634 5.20713 9.60394 5.29221 9.46167 5.43727C9.3194 5.58232 9.23807 5.77635 9.23438 5.97949V6.09949C9.23402 6.19735 9.25404 6.2942 9.29317 6.3839C9.33229 6.47359 9.38965 6.55416 9.46161 6.62048C9.53357 6.68679 9.61854 6.7374 9.71113 6.76908C9.80371 6.80076 9.90188 6.81282 9.99938 6.80449C10.1959 6.79707 10.3824 6.71567 10.5215 6.57659C10.6606 6.43752 10.742 6.25103 10.7494 6.05449V5.87449C10.75 5.77917 10.7304 5.68481 10.6919 5.59761C10.6533 5.51041 10.5968 5.43236 10.5259 5.36859C10.4551 5.30482 10.3715 5.25678 10.2808 5.22764C10.19 5.19849 10.0941 5.1889 9.99938 5.19949Z"
//                   fill="black"
//                   stroke="black"
//                   stroke-width="0.2"
//                 />
//               </svg>
//             </div>

//             <p className="w-full h-[20px] font-semibold text-[14px] text-black text-center mt-[16px]">
//               GST Certificate
//             </p>

//             <div className="w-full h-full flex items-center justify-center">
//               <form
//                 action=""
//                 onClick={() => document.querySelector(".input-field").click()}
//               >
//                 <input
//                   type="file"
//                   accept="application/pdf"
//                   className="input-field w-full h-full"
//                   hidden
//                   onChange={({ target: { files } }) => {
//                     files[0] && setFileName(files[0].name);
//                     if (files) {
//                       uploadDocuments(files[0]);
//                       setGstVerify(URL.createObjectURL(files[0]));
//                     }
//                   }}
//                 />

//                 {gstVerify ? (
//                   <div className="w-[72px] h-[72px] rounded-full bg-[#72C62F] flex items-center justify-center">
//                     <svg
//                       width="42"
//                       height="32"
//                       viewBox="0 0 42 32"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         d="M15.7419 29.6929C15.3209 30.1155 14.7244 30.4677 14.1981 30.4677C13.6718 30.4677 13.0754 30.0979 12.6368 29.6753L2.8125 19.8138L5.93522 16.6792L14.2157 24.991L36.1098 2.85547L39.1798 6.04285L15.7419 29.6929Z"
//                         fill="white"
//                         stroke="white"
//                         stroke-width="3"
//                       />
//                     </svg>
//                   </div>
//                 ) : (
//                   <>
//                     {/* <MdCloudUpload color="#1475cf" size={60} >
//               <img src={image} width={60} height={60} alt={fileName} />
//               </MdCloudUpload>
//               <p>Browse Files to Upload</p> */}
//                     <svg
//                       width="76"
//                       height="53"
//                       viewBox="0 0 76 53"
//                       className="cursor-pointer"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         d="M61.8684 22.3586C61.8684 22.1406 61.902 21.9227 61.902 21.7047C61.902 9.89805 53.2012 0.34375 42.468 0.34375C34.7246 0.34375 28.073 5.3207 24.9488 12.5137C23.5883 11.7689 22.0598 11.333 20.4473 11.333C15.4922 11.333 11.3602 15.3109 10.5707 20.5059C4.62461 22.7219 0.375 28.8795 0.375 36.127C0.375 45.2453 7.11055 52.6562 15.4082 52.6562H32.625V38.125H24.5289L38 22.9217L51.4711 38.1068H43.375V52.6381H61.902C69.4941 52.6381 75.625 45.8266 75.625 37.4893C75.625 29.152 69.4605 22.3768 61.8684 22.3586Z"
//                         fill="#FFC785"
//                       />
//                       <img
//                         src={gstVerify}
//                         width={60}
//                         height={60}
//                         alt={fileName}
//                       />
//                     </svg>
//                     <p className="w-[78px] h-[21px] font-medium text-[14px] text-black mt-[23px]">
//                       Upload File
//                     </p>
//                   </>
//                 )}
//               </form>
//             </div>
//           </div>
//           <hr className="w-full bg-[#E3E3E3] h-[1px]" />
//           {gstVerify ? (
//             <div className="w-[224px] h-[50px] rounded-b-[10px] flex flex-row pt-[14px] pl-[13px] pr-[17px] pb-[16px] items-center justify-between gap-x-[5px]">
//               <div className="h-[16px] font-medium text-[12px] text-black text-start w-[300px] overflow-x-scroll">
//                 {fileName}
//               </div>
//               <div className="w-[47px] h-[20px] flex items-center justify-between">
//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 19 19"
//                   className="cursor-pointer"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <g clip-path="url(#clip0_6502_1490)">
//                     <path
//                       d="M15.0423 10.9074V3.95833C15.0423 3.53841 14.8755 3.13568 14.5786 2.83875C14.2816 2.54181 13.8789 2.375 13.459 2.375H5.54232C5.12239 2.375 4.71966 2.54181 4.42273 2.83875C4.1258 3.13568 3.95898 3.53841 3.95898 3.95833V15.0417C3.95898 15.4616 4.1258 15.8643 4.42273 16.1613C4.71966 16.4582 5.12239 16.625 5.54232 16.625H10.5562"
//                       stroke="#FF6300"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                     <path
//                       d="M7.125 5.54163H11.875"
//                       stroke="#FF6300"
//                       stroke-width="1.5"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                     <path
//                       d="M7.125 8.70837H11.875"
//                       stroke="#FF6300"
//                       stroke-width="1.5"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                     <path
//                       d="M7.125 11.875H10.2917"
//                       stroke="#FF6300"
//                       stroke-width="1.5"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                     <g clip-path="url(#clip1_6502_1490)">
//                       <path
//                         d="M14.4257 16.6937C13.9631 16.6937 13.4853 16.5788 13.0046 16.3535C12.6281 16.1766 12.2486 15.9317 11.8767 15.6248C11.2493 15.1062 10.8623 14.5922 10.8456 14.571C10.7806 14.4848 10.7806 14.3669 10.8456 14.2807C10.8623 14.2596 11.2493 13.7455 11.8767 13.227C12.2486 12.9201 12.6281 12.6751 13.0046 12.4983C13.4853 12.273 13.9631 12.1581 14.4257 12.1581C14.8884 12.1581 15.3661 12.273 15.8469 12.4983C16.2233 12.6751 16.6028 12.9201 16.9747 13.227C17.6021 13.7455 17.9907 14.2596 18.0058 14.2807C18.0708 14.3669 18.0708 14.4848 18.0058 14.571C17.9892 14.5922 17.6021 15.1062 16.9747 15.6248C16.6028 15.9317 16.2233 16.1766 15.8469 16.3535C15.3661 16.5788 14.8884 16.6937 14.4257 16.6937ZM11.3506 14.4259C11.7301 14.8749 12.9834 16.2099 14.4257 16.2099C15.8711 16.2099 17.1214 14.8749 17.5009 14.4259C17.1214 13.9769 15.868 12.6419 14.4257 12.6419C12.9804 12.6419 11.7301 13.9769 11.3506 14.4259Z"
//                         fill="#FF6300"
//                       />
//                       <path
//                         d="M14.4264 15.5144C13.8262 15.5144 13.3379 15.026 13.3379 14.4258C13.3379 13.8256 13.8262 13.3373 14.4264 13.3373C15.0266 13.3373 15.515 13.8256 15.515 14.4258C15.515 15.026 15.0266 15.5144 14.4264 15.5144ZM14.4264 13.8211C14.0923 13.8211 13.8217 14.0917 13.8217 14.4258C13.8217 14.7599 14.0923 15.0306 14.4264 15.0306C14.7606 15.0306 15.0312 14.7599 15.0312 14.4258C15.0312 14.0917 14.7606 13.8211 14.4264 13.8211Z"
//                         fill="#FF6300"
//                       />
//                     </g>
//                   </g>
//                   <defs>
//                     <clipPath id="clip0_6502_1490">
//                       <rect width="19" height="19" fill="white" />
//                     </clipPath>
//                     <clipPath id="clip1_6502_1490">
//                       <rect
//                         width="7.74074"
//                         height="7.74074"
//                         fill="white"
//                         transform="translate(10.5547 10.5555)"
//                       />
//                     </clipPath>
//                   </defs>
//                 </svg>

//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 20 20"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="cursor-pointer"
//                   onClick={() => {
//                     setFileName("No uploads");
//                     setGstVerify(null);
//                   }}
//                 >
//                   <path
//                     d="M11.25 3.125H8.75C8.58424 3.125 8.42527 3.05915 8.30806 2.94194C8.19085 2.82473 8.125 2.66576 8.125 2.5C8.125 2.33424 8.19085 2.17527 8.30806 2.05806C8.42527 1.94085 8.58424 1.875 8.75 1.875H11.25C11.4158 1.875 11.5747 1.94085 11.6919 2.05806C11.8092 2.17527 11.875 2.33424 11.875 2.5C11.875 2.66576 11.8092 2.82473 11.6919 2.94194C11.5747 3.05915 11.4158 3.125 11.25 3.125Z"
//                     fill="#FF6300"
//                   />
//                   <path
//                     d="M16.25 3.75H3.75C3.58424 3.75 3.42527 3.81585 3.30806 3.93306C3.19085 4.05027 3.125 4.20924 3.125 4.375C3.125 4.54076 3.19085 4.69973 3.30806 4.81694C3.42527 4.93415 3.58424 5 3.75 5H4.375V16.25C4.3755 16.7471 4.5732 17.2238 4.92472 17.5753C5.27625 17.9268 5.75287 18.1245 6.25 18.125H13.75C14.2471 18.1245 14.7238 17.9268 15.0753 17.5753C15.4268 17.2238 15.6245 16.7471 15.625 16.25V5H16.25C16.4158 5 16.5747 4.93415 16.6919 4.81694C16.8092 4.69973 16.875 4.54076 16.875 4.375C16.875 4.20924 16.8092 4.05027 16.6919 3.93306C16.5747 3.81585 16.4158 3.75 16.25 3.75ZM14.375 16.25C14.375 16.4158 14.3092 16.5747 14.1919 16.6919C14.0747 16.8092 13.9158 16.875 13.75 16.875H6.25C6.08424 16.875 5.92527 16.8092 5.80806 16.6919C5.69085 16.5747 5.625 16.4158 5.625 16.25V5H14.375V16.25Z"
//                     fill="#FF6300"
//                   />
//                   <path
//                     d="M8.125 15C7.95924 15 7.80027 14.9342 7.68306 14.8169C7.56585 14.6997 7.5 14.5408 7.5 14.375V7.5C7.5 7.33424 7.56585 7.17527 7.68306 7.05806C7.80027 6.94085 7.95924 6.875 8.125 6.875C8.29076 6.875 8.44973 6.94085 8.56694 7.05806C8.68415 7.17527 8.75 7.33424 8.75 7.5V14.375C8.75 14.5408 8.68415 14.6997 8.56694 14.8169C8.44973 14.9342 8.29076 15 8.125 15ZM11.875 15C11.7092 15 11.5503 14.9342 11.4331 14.8169C11.3158 14.6997 11.25 14.5408 11.25 14.375V7.5C11.25 7.33424 11.3158 7.17527 11.4331 7.05806C11.5503 6.94085 11.7092 6.875 11.875 6.875C12.0408 6.875 12.1997 6.94085 12.3169 7.05806C12.4342 7.17527 12.5 7.33424 12.5 7.5V14.375C12.5 14.5408 12.4342 14.6997 12.3169 14.8169C12.1997 14.9342 12.0408 15 11.875 15Z"
//                     fill="#FF6300"
//                   />
//                 </svg>
//               </div>
//             </div>
//           ) : (
//             <div className="w-[224px] h-[50px] rounded-b-[10px] flex flex-row pt-[14px] pl-[13px] pr-[17px] pb-[16px] items-center justify-between gap-x-[5px] cursor-not-allowed">
//               <div className="h-[16px] font-medium text-[12px] text-[#D9D9D9] text-start">
//                 {fileName}
//               </div>
//               <div className="w-[47px] h-[20px] flex items-center justify-between">
//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 19 19"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <g clip-path="url(#clip0_1443_478)">
//                     <path
//                       d="M15.0443 10.9074V3.95833C15.0443 3.53841 14.8775 3.13568 14.5805 2.83875C14.2836 2.54181 13.8809 2.375 13.4609 2.375H5.54427C5.12434 2.375 4.72162 2.54181 4.42469 2.83875C4.12775 3.13568 3.96094 3.53841 3.96094 3.95833V15.0417C3.96094 15.4616 4.12775 15.8643 4.42469 16.1613C4.72162 16.4582 5.12434 16.625 5.54427 16.625H10.5582"
//                       stroke="#D9D9D9"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                     <path
//                       d="M7.125 5.54297H11.875"
//                       stroke="#D9D9D9"
//                       stroke-width="1.5"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                     <path
//                       d="M7.125 8.70703H11.875"
//                       stroke="#D9D9D9"
//                       stroke-width="1.5"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                     <path
//                       d="M7.125 11.875H10.2917"
//                       stroke="#D9D9D9"
//                       stroke-width="1.5"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                     <g clip-path="url(#clip1_1443_478)">
//                       <path
//                         d="M14.4257 16.6918C13.9631 16.6918 13.4853 16.5769 13.0046 16.3517C12.6281 16.1748 12.2486 15.9299 11.8767 15.623C11.2493 15.1044 10.8623 14.5904 10.8456 14.5692C10.7806 14.483 10.7806 14.3651 10.8456 14.2789C10.8623 14.2577 11.2493 13.7437 11.8767 13.2251C12.2486 12.9182 12.6281 12.6733 13.0046 12.4964C13.4853 12.2712 13.9631 12.1562 14.4257 12.1562C14.8884 12.1562 15.3661 12.2712 15.8469 12.4964C16.2233 12.6733 16.6028 12.9182 16.9747 13.2251C17.6021 13.7437 17.9907 14.2577 18.0058 14.2789C18.0708 14.3651 18.0708 14.483 18.0058 14.5692C17.9892 14.5904 17.6021 15.1044 16.9747 15.623C16.6028 15.9299 16.2233 16.1748 15.8469 16.3517C15.3661 16.5769 14.8884 16.6918 14.4257 16.6918ZM11.3506 14.424C11.7301 14.8731 12.9834 16.208 14.4257 16.208C15.8711 16.208 17.1214 14.8731 17.5009 14.424C17.1214 13.975 15.868 12.64 14.4257 12.64C12.9804 12.64 11.7301 13.975 11.3506 14.424Z"
//                         fill="#D9D9D9"
//                       />
//                       <path
//                         d="M14.4245 15.513C13.8243 15.513 13.3359 15.0247 13.3359 14.4245C13.3359 13.8243 13.8243 13.3359 14.4245 13.3359C15.0247 13.3359 15.513 13.8243 15.513 14.4245C15.513 15.0247 15.0247 15.513 14.4245 15.513ZM14.4245 13.8197C14.0904 13.8197 13.8197 14.0904 13.8197 14.4245C13.8197 14.7586 14.0904 15.0292 14.4245 15.0292C14.7586 15.0292 15.0292 14.7586 15.0292 14.4245C15.0292 14.0904 14.7586 13.8197 14.4245 13.8197Z"
//                         fill="#D9D9D9"
//                       />
//                     </g>
//                   </g>
//                   <defs>
//                     <clipPath id="clip0_1443_478">
//                       <rect width="19" height="19" fill="white" />
//                     </clipPath>
//                     <clipPath id="clip1_1443_478">
//                       <rect
//                         width="7.74074"
//                         height="7.74074"
//                         fill="white"
//                         transform="translate(10.5547 10.5547)"
//                       />
//                     </clipPath>
//                   </defs>
//                 </svg>

//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 20 20"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M11.25 3.125H8.75C8.58424 3.125 8.42527 3.05915 8.30806 2.94194C8.19085 2.82473 8.125 2.66576 8.125 2.5C8.125 2.33424 8.19085 2.17527 8.30806 2.05806C8.42527 1.94085 8.58424 1.875 8.75 1.875H11.25C11.4158 1.875 11.5747 1.94085 11.6919 2.05806C11.8092 2.17527 11.875 2.33424 11.875 2.5C11.875 2.66576 11.8092 2.82473 11.6919 2.94194C11.5747 3.05915 11.4158 3.125 11.25 3.125Z"
//                     fill="#D9D9D9"
//                   />
//                   <path
//                     d="M16.25 3.75H3.75C3.58424 3.75 3.42527 3.81585 3.30806 3.93306C3.19085 4.05027 3.125 4.20924 3.125 4.375C3.125 4.54076 3.19085 4.69973 3.30806 4.81694C3.42527 4.93415 3.58424 5 3.75 5H4.375V16.25C4.3755 16.7471 4.5732 17.2238 4.92472 17.5753C5.27625 17.9268 5.75287 18.1245 6.25 18.125H13.75C14.2471 18.1245 14.7238 17.9268 15.0753 17.5753C15.4268 17.2238 15.6245 16.7471 15.625 16.25V5H16.25C16.4158 5 16.5747 4.93415 16.6919 4.81694C16.8092 4.69973 16.875 4.54076 16.875 4.375C16.875 4.20924 16.8092 4.05027 16.6919 3.93306C16.5747 3.81585 16.4158 3.75 16.25 3.75ZM14.375 16.25C14.375 16.4158 14.3092 16.5747 14.1919 16.6919C14.0747 16.8092 13.9158 16.875 13.75 16.875H6.25C6.08424 16.875 5.92527 16.8092 5.80806 16.6919C5.69085 16.5747 5.625 16.4158 5.625 16.25V5H14.375V16.25Z"
//                     fill="#D9D9D9"
//                   />
//                   <path
//                     d="M8.125 15C7.95924 15 7.80027 14.9342 7.68306 14.8169C7.56585 14.6997 7.5 14.5408 7.5 14.375V7.5C7.5 7.33424 7.56585 7.17527 7.68306 7.05806C7.80027 6.94085 7.95924 6.875 8.125 6.875C8.29076 6.875 8.44973 6.94085 8.56694 7.05806C8.68415 7.17527 8.75 7.33424 8.75 7.5V14.375C8.75 14.5408 8.68415 14.6997 8.56694 14.8169C8.44973 14.9342 8.29076 15 8.125 15ZM11.875 15C11.7092 15 11.5503 14.9342 11.4331 14.8169C11.3158 14.6997 11.25 14.5408 11.25 14.375V7.5C11.25 7.33424 11.3158 7.17527 11.4331 7.05806C11.5503 6.94085 11.7092 6.875 11.875 6.875C12.0408 6.875 12.1997 6.94085 12.3169 7.05806C12.4342 7.17527 12.5 7.33424 12.5 7.5V14.375C12.5 14.5408 12.4342 14.6997 12.3169 14.8169C12.1997 14.9342 12.0408 15 11.875 15Z"
//                     fill="#D9D9D9"
//                   />
//                 </svg>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//     // </div>
//   );
// };

// export default UploadDocuments;

import React, { useState } from "react";
import { ViewSVG, DeleteSVG, InfoSVG } from "../../../assets/svg/documentsModelSvg";

const UploadDocuments = ({ gstVerify, aadharVerify, passportVerify, licenseVerify, setGstVerify, setAadharVerify, setPassportVerify, setLicenseVerify, setError, error }) => {
  
  const [fileName, setFileName] = useState("No uploads");

  return (
    // <div className="w-full h-[800px] flex items-center justify-center">
    <div className="w-[959px] h-[480px] rounded-[20px] bg-white flex flex-col items-center justify-start">
      <img
        src={require("../../../assets/BuyerProfile/StoreManager/UploadDocuments/Naayatrade Final Logo File 1.jpg")}
        alt=""
        className="w-[31px] h-[39px]"
      />
      <h4 className="w-[411px] h-[21px] font-semibold text-[14px] text-black text-center mt-[16px]">
        Upload documents for verification ( Allowed file type .pdf)
      </h4>

      <div className="w-[959px] h-[292px] flex flex-row gap-x-[21px] mt-4">
        <div className="w-[224px] h-[292px] border rounded-[10px] flex flex-col">
          <div className="w-full h-[242px] p-[13px] flex flex-col rounded-t-[10px]">
            <div className="w-full flex justify-end">
              {InfoSVG()}
            </div>

            <p className="w-full h-[20px] font-semibold text-[14px] text-black text-center mt-[37px]">
              GST Certificate
            </p>

            <div className="w-full h-full flex items-center justify-center">
              <form
                action=""
                onClick={() => document.querySelector(".input-field").click()}
              >
                <input
                  type="file"
                  accept="application/pdf"
                  className="input-field w-full h-full"
                  hidden
                  onChange={({ target: { files } }) => {
                      setGstVerify(files[0]);
                      setError("");
                  }}
                />

                {gstVerify ? (
                  <div className="w-[72px] h-[72px] rounded-full bg-[#72C62F] flex items-center justify-center">
                    <svg
                      width="42"
                      height="32"
                      viewBox="0 0 42 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.7419 29.6929C15.3209 30.1155 14.7244 30.4677 14.1981 30.4677C13.6718 30.4677 13.0754 30.0979 12.6368 29.6753L2.8125 19.8138L5.93522 16.6792L14.2157 24.991L36.1098 2.85547L39.1798 6.04285L15.7419 29.6929Z"
                        fill="white"
                        stroke="white"
                        stroke-width="3"
                      />
                    </svg>
                  </div>
                ) : (
                  <>
                    <svg
                      width="76"
                      height="53"
                      viewBox="0 0 76 53"
                      className="cursor-pointer"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M61.8684 22.3586C61.8684 22.1406 61.902 21.9227 61.902 21.7047C61.902 9.89805 53.2012 0.34375 42.468 0.34375C34.7246 0.34375 28.073 5.3207 24.9488 12.5137C23.5883 11.7689 22.0598 11.333 20.4473 11.333C15.4922 11.333 11.3602 15.3109 10.5707 20.5059C4.62461 22.7219 0.375 28.8795 0.375 36.127C0.375 45.2453 7.11055 52.6562 15.4082 52.6562H32.625V38.125H24.5289L38 22.9217L51.4711 38.1068H43.375V52.6381H61.902C69.4941 52.6381 75.625 45.8266 75.625 37.4893C75.625 29.152 69.4605 22.3768 61.8684 22.3586Z"
                        fill="#FFC785"
                      />
                      <img
                        src={gstVerify}
                        width={60}
                        height={60}
                        alt={fileName}
                      />
                    </svg>
                    <p className="w-[78px] h-[21px] font-medium text-[14px] text-black mt-[23px]">
                      Upload File
                    </p>
                  </>
                )}
              </form>
            </div>
          </div>
          <hr className="w-full bg-[#E3E3E3] h-[1px]" />
          {gstVerify ? (
            <div className="w-[224px] h-[50px] rounded-b-[10px] flex flex-row pt-[14px] pl-[13px] pr-[17px] pb-[16px] items-center justify-between gap-x-[5px]">
              <div className="h-[16px] font-medium text-[12px] text-black text-start w-[300px] overflow-x-scroll">
                {fileName}
              </div>
              <div className="w-[47px] h-[20px] flex items-center justify-between">
                {ViewSVG()}
                <p
                  onClick={() => {
                    setFileName("No uploads");
                    setGstVerify(null);
                  }}  
                >
                  {DeleteSVG()}
                </p>
              </div>
            </div>
          ) : (
            <div className="w-[224px] h-[50px] rounded-b-[10px] flex flex-row pt-[14px] pl-[13px] pr-[17px] pb-[16px] items-center justify-between gap-x-[5px] cursor-not-allowed">
              <div className="h-[16px] font-medium text-[12px] text-[#D9D9D9] text-start">
                {fileName}
              </div>
              <div className="w-[47px] h-[20px] flex items-center justify-between">
                {ViewSVG("#D9D9D9")}
                {DeleteSVG("#D9D9D9")}
              </div>
            </div>
          )}
        </div>
        {/* Aadhar Submission */}
        <div className="w-[224px] h-[292px] border rounded-[10px] flex flex-col">
          <div className="w-full h-[242px] p-[13px] flex flex-col rounded-t-[10px]">
            <div className="w-full flex justify-end">{InfoSVG()}</div>
            <p className="w-full h-[20px] font-semibold text-[14px] text-black text-center mt-[16px]">
              Aadhar Certificate
            </p>

            <div className="w-full h-full flex items-center justify-center">
              <form
                action=""
                onClick={() => document.querySelector(".aadhar-input-field").click()}
              >
                <input
                  type="file"
                  accept="application/pdf"
                  className="aadhar-input-field w-full h-full"
                  hidden
                  onChange={({ target: { files } }) => {
                      setAadharVerify(files[0]);
                      setError("");
                  }}
                />

                {aadharVerify ? (
                  <div className="w-[72px] h-[72px] rounded-full bg-[#72C62F] flex items-center justify-center">
                    <svg
                      width="42"
                      height="32"
                      viewBox="0 0 42 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.7419 29.6929C15.3209 30.1155 14.7244 30.4677 14.1981 30.4677C13.6718 30.4677 13.0754 30.0979 12.6368 29.6753L2.8125 19.8138L5.93522 16.6792L14.2157 24.991L36.1098 2.85547L39.1798 6.04285L15.7419 29.6929Z"
                        fill="white"
                        stroke="white"
                        stroke-width="3"
                      />
                    </svg>
                  </div>
                ) : (
                  <>
                    <svg
                      width="76"
                      height="53"
                      viewBox="0 0 76 53"
                      className="cursor-pointer"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M61.8684 22.3586C61.8684 22.1406 61.902 21.9227 61.902 21.7047C61.902 9.89805 53.2012 0.34375 42.468 0.34375C34.7246 0.34375 28.073 5.3207 24.9488 12.5137C23.5883 11.7689 22.0598 11.333 20.4473 11.333C15.4922 11.333 11.3602 15.3109 10.5707 20.5059C4.62461 22.7219 0.375 28.8795 0.375 36.127C0.375 45.2453 7.11055 52.6562 15.4082 52.6562H32.625V38.125H24.5289L38 22.9217L51.4711 38.1068H43.375V52.6381H61.902C69.4941 52.6381 75.625 45.8266 75.625 37.4893C75.625 29.152 69.4605 22.3768 61.8684 22.3586Z"
                        fill="#FFC785"
                      />
                      <img
                        src={aadharVerify}
                        width={60}
                        height={60}
                        alt={fileName}
                      />
                    </svg>
                    <p className="w-[78px] h-[21px] font-medium text-[14px] text-black mt-[23px]">
                      Upload File
                    </p>
                  </>
                )}
              </form>
            </div>
          </div>
          <hr className="w-full bg-[#E3E3E3] h-[1px]" />
          {aadharVerify ? (
            <div className="w-[224px] h-[50px] rounded-b-[10px] flex flex-row pt-[14px] pl-[13px] pr-[17px] pb-[16px] items-center justify-between gap-x-[5px]">
              <div className="h-[16px] font-medium text-[12px] text-black text-start w-[300px] overflow-x-scroll">
                {fileName}
              </div>
              <div className="w-[47px] h-[20px] flex items-center justify-between">
                {ViewSVG()}
                <p
                  onClick={() => {
                    setFileName("No uploads");
                    setAadharVerify(null);
                  }}  
                >
                  {DeleteSVG()}
                </p>
              </div>
            </div>
          ) : (
            <div className="w-[224px] h-[50px] rounded-b-[10px] flex flex-row pt-[14px] pl-[13px] pr-[17px] pb-[16px] items-center justify-between gap-x-[5px] cursor-not-allowed">
              <div className="h-[16px] font-medium text-[12px] text-[#D9D9D9] text-start">
                {fileName}
              </div>
              <div className="w-[47px] h-[20px] flex items-center justify-between">
                {ViewSVG("#D9D9D9")}
                {DeleteSVG("#D9D9D9")}
              </div>
            </div>
          )}
        </div>
        {/* Passport Submission */}
        <div className="w-[224px] h-[292px] border rounded-[10px] flex flex-col">
          <div className="w-full h-[242px] p-[13px] flex flex-col rounded-t-[10px]">
            <div className="w-full flex justify-end">{InfoSVG()}</div>
            <p className="w-full h-[20px] font-semibold text-[14px] text-black text-center mt-[16px]">
              Passport Certificate
            </p>

            <div className="w-full h-full flex items-center justify-center">
              <form
                action=""
                onClick={() => document.querySelector(".passport-input-field").click()}
              >
                <input
                  type="file"
                  accept="application/pdf"
                  className="passport-input-field w-full h-full"
                  hidden
                  onChange={({ target: { files } }) => {
                      setPassportVerify(files[0]);
                      setError("");
                  }}
                />

                {passportVerify ? (
                  <div className="w-[72px] h-[72px] rounded-full bg-[#72C62F] flex items-center justify-center">
                    <svg
                      width="42"
                      height="32"
                      viewBox="0 0 42 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.7419 29.6929C15.3209 30.1155 14.7244 30.4677 14.1981 30.4677C13.6718 30.4677 13.0754 30.0979 12.6368 29.6753L2.8125 19.8138L5.93522 16.6792L14.2157 24.991L36.1098 2.85547L39.1798 6.04285L15.7419 29.6929Z"
                        fill="white"
                        stroke="white"
                        stroke-width="3"
                      />
                    </svg>
                  </div>
                ) : (
                  <>
                    <svg
                      width="76"
                      height="53"
                      viewBox="0 0 76 53"
                      className="cursor-pointer"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M61.8684 22.3586C61.8684 22.1406 61.902 21.9227 61.902 21.7047C61.902 9.89805 53.2012 0.34375 42.468 0.34375C34.7246 0.34375 28.073 5.3207 24.9488 12.5137C23.5883 11.7689 22.0598 11.333 20.4473 11.333C15.4922 11.333 11.3602 15.3109 10.5707 20.5059C4.62461 22.7219 0.375 28.8795 0.375 36.127C0.375 45.2453 7.11055 52.6562 15.4082 52.6562H32.625V38.125H24.5289L38 22.9217L51.4711 38.1068H43.375V52.6381H61.902C69.4941 52.6381 75.625 45.8266 75.625 37.4893C75.625 29.152 69.4605 22.3768 61.8684 22.3586Z"
                        fill="#FFC785"
                      />
                      <img
                        src={passportVerify}
                        width={60}
                        height={60}
                        alt={fileName}
                      />
                    </svg>
                    <p className="w-[78px] h-[21px] font-medium text-[14px] text-black mt-[23px]">
                      Upload File
                    </p>
                  </>
                )}
              </form>
            </div>
          </div>
          <hr className="w-full bg-[#E3E3E3] h-[1px]" />
          {passportVerify ? (
            <div className="w-[224px] h-[50px] rounded-b-[10px] flex flex-row pt-[14px] pl-[13px] pr-[17px] pb-[16px] items-center justify-between gap-x-[5px]">
              <div className="h-[16px] font-medium text-[12px] text-black text-start w-[300px] overflow-x-scroll">
                {fileName}
              </div>
              <div className="w-[47px] h-[20px] flex items-center justify-between">
                {ViewSVG()}
                <p
                  onClick={() => {
                    setFileName("No uploads");
                    setPassportVerify(null);
                  }}  
                >
                  {DeleteSVG()}
                </p>
              </div>
            </div>
          ) : (
            <div className="w-[224px] h-[50px] rounded-b-[10px] flex flex-row pt-[14px] pl-[13px] pr-[17px] pb-[16px] items-center justify-between gap-x-[5px] cursor-not-allowed">
              <div className="h-[16px] font-medium text-[12px] text-[#D9D9D9] text-start">
                {fileName}
              </div>
              <div className="w-[47px] h-[20px] flex items-center justify-between">
                {ViewSVG("#D9D9D9")}
                {DeleteSVG("#D9D9D9")}
              </div>
            </div>
          )}
        </div>
        {/* Driving License Submission */}
        <div className="w-[224px] h-[292px] border rounded-[10px] flex flex-col">
          <div className="w-full h-[242px] p-[13px] flex flex-col rounded-t-[10px]">
            <div className="w-full flex justify-end">{InfoSVG()}</div>
            <p className="w-full h-[20px] font-semibold text-[14px] text-black text-center mt-[16px]">
              DL Certificate
            </p>

            <div className="w-full h-full flex items-center justify-center">
              <form
                action=""
                onClick={() => document.querySelector(".dl-input-field").click()}
              >
                <input
                  type="file"
                  accept="application/pdf"
                  className="dl-input-field w-full h-full"
                  hidden
                  onChange={({ target: { files } }) => {
                    setLicenseVerify(files[0]);
                    setError("");
                  }}
                />

                {licenseVerify ? (
                  <div className="w-[72px] h-[72px] rounded-full bg-[#72C62F] flex items-center justify-center">
                    <svg
                      width="42"
                      height="32"
                      viewBox="0 0 42 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.7419 29.6929C15.3209 30.1155 14.7244 30.4677 14.1981 30.4677C13.6718 30.4677 13.0754 30.0979 12.6368 29.6753L2.8125 19.8138L5.93522 16.6792L14.2157 24.991L36.1098 2.85547L39.1798 6.04285L15.7419 29.6929Z"
                        fill="white"
                        stroke="white"
                        stroke-width="3"
                      />
                    </svg>
                  </div>
                ) : (
                  <>
                    <svg
                      width="76"
                      height="53"
                      viewBox="0 0 76 53"
                      className="cursor-pointer"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M61.8684 22.3586C61.8684 22.1406 61.902 21.9227 61.902 21.7047C61.902 9.89805 53.2012 0.34375 42.468 0.34375C34.7246 0.34375 28.073 5.3207 24.9488 12.5137C23.5883 11.7689 22.0598 11.333 20.4473 11.333C15.4922 11.333 11.3602 15.3109 10.5707 20.5059C4.62461 22.7219 0.375 28.8795 0.375 36.127C0.375 45.2453 7.11055 52.6562 15.4082 52.6562H32.625V38.125H24.5289L38 22.9217L51.4711 38.1068H43.375V52.6381H61.902C69.4941 52.6381 75.625 45.8266 75.625 37.4893C75.625 29.152 69.4605 22.3768 61.8684 22.3586Z"
                        fill="#FFC785"
                      />
                      <img
                        src={licenseVerify}
                        width={60}
                        height={60}
                        alt={fileName}
                      />
                    </svg>
                    <p className="w-[78px] h-[21px] font-medium text-[14px] text-black mt-[23px]">
                      Upload File
                    </p>
                  </>
                )}
              </form>
            </div>
          </div>
          <hr className="w-full bg-[#E3E3E3] h-[1px]" />
          {licenseVerify ? (
            <div className="w-[224px] h-[50px] rounded-b-[10px] flex flex-row pt-[14px] pl-[13px] pr-[17px] pb-[16px] items-center justify-between gap-x-[5px]">
              <div className="h-[16px] font-medium text-[12px] text-black text-start w-[300px] overflow-x-scroll">
                {fileName}
              </div>
              <div className="w-[47px] h-[20px] flex items-center justify-between">
                {ViewSVG()}
                <p
                  onClick={() => {
                    setFileName("No uploads");
                    setLicenseVerify(null);
                  }}  
                >
                  {DeleteSVG()}
                </p>
              </div>
            </div>
          ) : (
            <div className="w-[224px] h-[50px] rounded-b-[10px] flex flex-row pt-[14px] pl-[13px] pr-[17px] pb-[16px] items-center justify-between gap-x-[5px] cursor-not-allowed">
              <div className="h-[16px] font-medium text-[12px] text-[#D9D9D9] text-start">
                {fileName}
              </div>
              <div className="w-[47px] h-[20px] flex items-center justify-between">
                {ViewSVG("#D9D9D9")}
                {DeleteSVG("#D9D9D9")}
              </div>
            </div>
          )}
        </div>
      </div>
      {error && <p className="text-red-400 mt-4">{error}</p>}
    </div>
  );
};

export default UploadDocuments;
